import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

type DealTerm = {
  id: number;
  text: string;
};

interface DealFeaturesProps {
  terms: DealTerm[];
}

export function DealFeatures({ terms }: DealFeaturesProps) {
  return (
    <section id="pricePlans" className="py-8">
      <h3 className="mb-2 font-header text-3xl font-bold">
        Plans &amp; Features
      </h3>
      <h5 className="mb-4 font-header text-xl font-semibold">
        Deal terms &amp; conditions
      </h5>
      <ul className="flex flex-col gap-y-2">
        {terms.map((term) => (
          <li key={term.id} className="flex gap-x-2 leading-6">
            <FontAwesomeIcon icon={faCheck} className="mt-1 text-dollar" />
            <span dangerouslySetInnerHTML={{ __html: term.text }} />
          </li>
        ))}
      </ul>
    </section>
  );
}
